import React, { ChangeEvent } from 'react';

import {
    InputGroup,
    Label,
    ElementWrap,
    ReasonSelect,
    FieldSubText,
} from '../cancelPolicyFormStyles';
import { SelectChevron } from './cancelReasonStyles';
import ChevronIconSrc from '../../../../assets/images/chevron-down.svg';
import { string } from 'prop-types';

interface initialState {
    value: string;
    active: boolean;
    error: boolean;
    msg: string;
}

interface props {
    state: initialState;
    onFocus: Function;
    onBlur: Function;
    onChange: Function;
    disabled: boolean;
}

export const initialState: initialState = {
    value: '',
    active: false,
    error: false,
    msg: ''
};


interface RefundMethodsProps {
    state: initialState;
    systemCode: string;
    onFocus: Function;
    onBlur: Function;
    onChange: Function;
    disabled: boolean;
    refundOptions: string[];
    setRefundMethod: Function;
    product: string;
    cancellationReason: string;

}

export const isValid = (value: string) =>
    value !== 'Select refund method' && value !== '';


export default ({
    state: { value, active, error, msg },
    systemCode,
    onFocus,
    onBlur,
    onChange,
    disabled,
    refundOptions,      //this has response.
    setRefundMethod,
    product,
    cancellationReason
}: RefundMethodsProps) => (
    <div style={{ display: (product === 'WORKERS COMP' || product === 'COMMERCIAL PACKAGE' || product === 'Inland Marine' || product === 'General Liability' ? 'none' : 'block') }}>
        <InputGroup test-attr="cancel-policy-cancellation-reason"
        >
            <Label active={active} error={error}
            >
                Refund Method
            </Label>
            <ElementWrap active={active} error={error}>
                <ReasonSelect
                    onFocus={() => onFocus()}
                    onBlur={() => onBlur()}
                    value={value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                        const val = e.target.value;
                        if (product === 'WORKERS COMP' || product === 'COMMERCIAL PACKAGE' || product === 'Inland Marine' || product === 'General Liability') {
                            value = refundOptions[1];
                        }
                        onChange(e.target.value);
                        if (refundOptions.includes(val) && val !== 'Select refund method') {
                            setRefundMethod(val);
                        }
                    }}
                    disabled={disabled}
                >
                    {refundOptions.map(option => (
                        <option key={option} value={option} style={{fontSize:'15px'}}>
                            {option}
                        </option>
                    ))}
                </ReasonSelect>
                <SelectChevron src={ChevronIconSrc} />
            </ElementWrap>
            <FieldSubText error={error}>{msg}</FieldSubText>
        </InputGroup>
    </div>
);

